import { InputField } from '@atoms/input';
import { SwitchField } from '@atoms/switch';
import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB, {
  type SettingsConfig
} from '@library/formBuilder/endControls';
import { FormControl, FormLabel, Textarea } from '@mui/joy';
import { type DNDBlock, ResolvedVariableType } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import type { ChangeEvent } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialCommentData } from './comment.data';
import { CommentModal } from './comment.modal';
import { CommentIcon } from './comment.utils';

const Comment = (block: DNDBlock) => {
  const actionId = useParams()[ParamsList.ActionId] as string;

  const atom = useAtom({
    type: 'Comment',
    sourceId: block.id,
    parentId: actionId,
    parentKind: 'form_action',
    initialData: initialCommentData,
    variableInfo: {
      resolvedType: ResolvedVariableType.Comment
    }
  });

  if (!atom) {
    return null;
  }

  const getSettingsModal = (): SettingsConfig => ({
    title: atom.data.title || 'Comment title',
    content: <CommentModal atom={atom} />
  });

  const getEndControls = () => (
    <EndControlsFB
      dataItem={atom}
      dndBlock={block}
      hasRequired
      settings={getSettingsModal()}
    />
  );

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={getEndControls()}
      icon={CommentIcon}
      title={atom.data.title}
    >
      <Column>
        <InputField
          label="Field title"
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            atom.data.title = e.target.value;
          }}
          placeholder="Aa"
          required
          value={atom.data.title}
        />
      </Column>

      <Column $width="300px">
        <FormControl size="sm">
          <FormLabel>Placeholder</FormLabel>
          <Textarea
            maxRows={4}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
              atom.data.placeholder = e.target.value;
            }}
            placeholder="Aa"
            value={atom.data.placeholder}
          />
        </FormControl>
      </Column>

      <Column $gap="0">
        <FormControl size="sm">
          <FormLabel>Additional features</FormLabel>
        </FormControl>
        <SwitchField
          checked={atom.data.withMention}
          label="Allow mentions"
          onChange={e => {
            atom.data.withMention = e.target.checked;
          }}
        />
      </Column>
    </BlockBase>
  );
};

export default observer(Comment);
